export const base64Encode = (b) => b.match(/.{2}/g).map((n) => String.fromCharCode(parseInt(n, 16) >> 1)).join("");